import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MessageService, SharedModule } from 'primeng/api';
import { Button } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { Tag } from 'primeng/tag';
import SampleProcessLog from '../../../../types/sample-process-log/SampleProcessLog';
import Page from '../../../../types/shared/Page';
import HomeStats from '../../../../types/stats/HomeStats';
import { EnumLabelPipe } from '../../pipes/enum-label.pipe';
import { FormatDateTime } from '../../pipes/format-date-time';
import { SampleStateSeverityPipe } from '../../pipes/sample-state-severity.pipe';
import { AuthService } from '../../services/auth.service';
import { SampleProcessLogService } from '../../services/sample-process-log.service';
import { StatsService } from '../../services/stats.service';
import { CumulativeSampleChartComponent } from './cumulative-sample-chart/cumulative-sample-chart.component';
import { SampleProcessLogChartComponent } from './sample-process-log-chart/sample-process-log-chart.component';

@Component({
    selector: 'app-home',
    imports: [
        SharedModule,
        TableModule,
        SampleStateSeverityPipe,
        EnumLabelPipe,
        Tag,
        FormatDateTime,
        SampleProcessLogChartComponent,
        CumulativeSampleChartComponent,
        Button,
        RouterLink
    ],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent implements AfterViewInit {

    public totalRecords = 0;
    public rows = 5;
    public currentPage = 0;
    public loading = false;

    public homeStats: HomeStats = new HomeStats({});
    public processLogs: SampleProcessLog[] = [];

    constructor(private statsService: StatsService,
                private messageService: MessageService,
                private sampleProcessLogService: SampleProcessLogService,
                private authService: AuthService,
                private cdr: ChangeDetectorRef) {
    }

    public canSeeVehicleModels(): boolean {
        return this.authService.canSeeVehicleModels();
    }

    /**
     * Lifecycle hook that is called after the component's view has been fully initialized.
     * Loads the home stats
     */
    public ngAfterViewInit(): void {
        this.loadStats();
    }

    /**
     * Handler for the page change event. Sets the current page and rows, and loads the process logs.
     *
     * @param event The event object containing pagination information.
     */
    public onPageChange(event: any): void {
        this.currentPage = Math.floor(event.first / event.rows);
        this.rows = event.rows;
        this.loadProcessLogs();
    }

    /**
     * Loads the home stats from the server.
     */
    private loadStats(): void {
        this.statsService.getHomeStats().then((stats) => {
            this.homeStats = stats;
            this.cdr.markForCheck();
        }).catch(() => {
            this.messageService.add(
                { severity: 'error', summary: 'Error', detail: 'Failed to load home stats' }
            );
        });
    }

    /**
     * Loads the latest sample process logs from the server.
     */
    private loadProcessLogs(): void {
        const size = this.rows;
        this.sampleProcessLogService.getLatestSampleProcessLogs(this.currentPage, size)
            .then((logs: Page<SampleProcessLog>) => {
                this.processLogs = logs.content as SampleProcessLog[] || [];
                this.totalRecords = logs.page.totalElements || 0;
                this.currentPage = logs.page.number || 0;
                this.cdr.markForCheck();
            }).catch((error: any) => {
            console.error('Failed to load latest sample process logs:', error);
            this.messageService.add(
                { severity: 'error', summary: 'Error', detail: 'Failed to load latest sample process logs' }
            );
        });
    }

}
